module.exports = __webpack_public_path__ + "static/01-illustration-faa2be9f14bf44f9b1fddcb5124ada1f.svg";